{
  "articlesSection": "文章",
  "bookmarkTitleLabel": "書籤",
  "communitiesSection": "社群討論",
  "devConnectionLabel": "開發人員連線",
  "feedback": "意見反應",
  "fetchFailed": "擷取失敗",
  "help": "說明",
  "helpLoadError": "發生錯誤，請再試一次。",
  "noBookmarks": "為說明內容加入書籤，即可在此存取",
  "noBookmarksTitle": "沒有書籤",
  "noResults": "找不到任何結果",
  "noResultsMessage": "檢查拼字或使用其他搜尋字詞",
  "resourcesCustomerCareLabel": "客戶服務",
  "resourcesStatusLabel": "狀態",
  "solutionsFilterLabel": "所有解決方案",
  "support": "支援",
  "videosSection": "影片"
}
